
// Porbably never used. Use the next func instead.
window.getVariant = function() {
  console.log('Delete this function.')
  return $('input[name=Size]:checked', 'fieldset[name=Size]').val()
}

g_getSelectedVariantId = function() {
  return document.querySelector('form[data-type="add-to-cart-form"] input[name="id"]')?.value
}

// On product page get currently selected variant
g_getSelectedVariant = function() {
  if (!window.g_product) return
  let ident = window.g_product.options[0]
  return $('input[name="'+ident+'"]:checked', 'fieldset[data-option-name="'+ident.toLowerCase()+'"]').val()
}

g_getSelectedVariants = function() {
  let variants = []
  if (!g_product) return variants
  g_product.options.forEach(ident => {
    variants.push($('fieldset[data-option-name="'+ident.toLowerCase()+'"] input[name="'+ident+'"]:checked').val())
  })
  // console.log(variants)
  return variants
}

// Returns an object if {key: val} exists
function getObjByKeyValPair(list, key, val) {
  for (const item of list) {
    if (item[key] == val) return item
  }
  return null
}

function Obj(object) {

  function Wrapper(obj) {
    this.obj = obj;
  }

  Wrapper.prototype.filterByKey = function(func) {
    let newObj = {}
    Object.keys(this.obj).forEach(key => {
      if (func(key)) newObj[key] = this.obj[key]
    })
    return newObj
  }

  Wrapper.prototype.filterByVal = function(func) {
  	let newObj = {}
  	for (let [key, val] of Object.entries(this.obj)) {
  	  if (func(val)) newObj[key] = val
  	}
  	return newObj
  }

  Wrapper.prototype.filterByKeyVal = function(func) {
  	let newObj = {}
  	for (let [key, val] of Object.entries(this.obj)) {
      if (func(key, val)) newObj[key] = val
  	}
  	return newObj
  }

  return new Wrapper(object);
}

function Arr(array) {

  function Wrapper(arr) {
    this.array = arr
    console.log('this.array', this.array)
  }

  Wrapper.prototype.filterByObj = function(func) {
  	let newArray = []
    for (const obj of this.array) {
      if (func(obj)) newArray.push(obj)
    }
    return newArray
  }

  return new Wrapper(array)
}

// Edit
g_edit = function() {
    document.location = '/admin/products/'+g_product.id
}

$(document).ready(function() {
    if (!window.location.pathname.includes('/products/')) return

    let h1DoubleClicked = false;
    let typedSequence = '';
    let sequenceTimeout;
    let keypressHandler;

    $('h1').on('dblclick', function() {
        h1DoubleClicked = true;
        typedSequence = '';
        
        // Only add keypress listener when needed
        if (!keypressHandler) {
            keypressHandler = function(e) {
                if (h1DoubleClicked) {
                    typedSequence += String.fromCharCode(e.which).toLowerCase();
                    
                    if (typedSequence.includes('edit')) {
                        g_edit();
                        resetSequence();
                    }               
                    
                    if (typedSequence.length > 10) {
                        typedSequence = typedSequence.slice(-4);
                    }
                }
                
            };
            $(document).on('keypress', keypressHandler);
        }
        
        clearTimeout(sequenceTimeout);
        sequenceTimeout = setTimeout(resetSequence, 5000);
    });
    
    function resetSequence() {
        h1DoubleClicked = false;
        typedSequence = '';
        if (keypressHandler) {
            $(document).off('keypress', keypressHandler);
            keypressHandler = null;
        }
    }
});



/*
____________________________
 
  VALIDATOR
____________________________
 
*/

//
// Error Class
// _________________

class ValidatorError {
	
	$h = $([])
    handle = ''
    hideMsgOnSuccess = true
    classesToRemoveOnSuccess = 'error-flag'
    afterSuccess = null
    errorMsg = ''
    showMsgOnError = true
    classesToAddOnError = 'error-flag'
    disableSubmit = true
    afterError = null
	
	constructor(config) {
        for (let key in config)
          this[key] = config[key]
	}

	isValid(input) {
		return this.isValid(input)
	}

	onSuccess(field) {
		if (this.hideMsgOnSuccess)
			this.$h.slideUp()

		if (this.afterSuccess)
			this.afterSuccess(field, this)
	}

	onError(field) {
		if (this.showMsgOnError)
            this.$h.slideDown()

		if (this.afterError)
			this.afterError(field, this)
	}
}

//
// Field Class
// _____________________

class ValidatorField {

	$h = $([])
	errors = []

	constructor(config) {
		this.errors = config.errors
		if (config.$h) this.$h = config.$h
    }

	getInput() {
		return this.$h.val()
	}

	// Returns a list of errors
    //
	validate(inputVal) {
      let errorList = []
      let successList = []

      for (let error of this.errors) {
        
          let input = inputVal || this.getInput()
        
          if (error.isValid(input)) {
              error.onSuccess(this)
              successList.push(error)
          }
          else {
              error.onError(this)
              errorList.push(error)
          }
      }

      this.addRemoveClasses(errorList, successList)
    
      return errorList
	}

    addRemoveClasses(errorList, successList) {
      let toAdd = []
      let toRemove = []
      
      for (let error of successList)
        toRemove.push(error.classesToRemoveOnSuccess)

      for (let error of errorList)
        toAdd.push(error.classesToAddOnError)

      this.$h
        .removeClass(toRemove.join(' '))
        .addClass(toAdd.join(' '))
    }
  
}
 

$(document).ready(() => {

    $('t').each(function() {
        $(this).html($(this).text())
    })
  
  // Move Language Switcher to navigation bar (on mobile)
  $('ul.mobile-nav__social').after('<div id="new-mobile-weglot-container" class="appear-animation appear-delay-9">'+$('#weglot-language-translation').html()+'</div>')
  let $originalWeglotContainer = $('#weglot-mobile-switcher').detach()
  $originalWeglotContainer.appendTo('#new-mobile-weglot-container')
  $originalWeglotContainer.find('div:first').show()
  
  // Temp logo change
  // $('.header-item--logo-split img').parent().html('<img style="width: 110px" src="https://cdn.shopify.com/s/files/1/0252/8526/3469/files/equa-logo2023.png?v=1692792788">')
 
  // Marked words
  if (TEST) {
    MarkedText.init()
    // $('span.marked').append('<img src="https://cdn.shopify.com/s/files/1/0252/8526/3469/files/marker.png?v=1695805834">')
  }
  
  if (location.search === '?test1234') {
    theme.cart.getCart().then(function(data) {
      cartContents = ''
      
      data.items.forEach(item => {
        let properties = ''
        for (propKey in item.properties) {
          let propVal = item.properties[propKey]
          properties += '<div style="padding-left: 20px; color: grey">' + propKey + ': ' + propVal + '</div>'
        }
        cartContents += '<div>' + item.id + ' ' + item.title + ', qty: ' + item.quantity + properties + '</div>'
      })

      $('body').prepend('<div style="padding: 100px 10px">CART<br><br>' + cartContents + '</div>')
    })
  }
})

/*
  Free gifts progress bar + auto-add gifts.

  MASTER SWITCH (theme-custom.js only — not Theme settings):
    FreeGifts.ENABLED = true  → show gauge + auto gifts
    FreeGifts.ENABLED = false → hide everything

  Gauge steps: edit getSteps() below. Comment out any push(...) block
  to remove that point from the bar and stop auto-adding that gift.

  Properties (hidden in cart UI):
    _added-free      - gift type: frother | immunity | flask
    _added-free-lang - locale locked when gift was first added
*/

var FreeShipping = {
  formatEur: function(amount) {
    var rounded = Math.round(amount * 100) / 100
    if (rounded === Math.round(rounded)) {
      return Math.round(rounded) + ' EUR'
    }
    return rounded.toFixed(2) + ' EUR'
  },

  setMsg: function($el, visible, text) {
    if (!$el.length) return
    $el.toggleClass('is-visible', !!visible)
    if (visible && text !== undefined) $el.html(text)
  },

  setMilestone: function($el, reached, isNext, label) {
    $el.toggleClass('is-reached', !!reached)
    $el.toggleClass('is-next', !!isNext && !reached)
    if (label) $el.find('.gm-label').text(label)
  },

  i18n: function() {
    var config = window.FreeGifts && FreeGifts.loadConfig ? FreeGifts.loadConfig() : null
    return (config && config.i18n) || {}
  },

  tpl: function(template, amount) {
    if (!template) return ''
    var formatted = this.formatEur(amount)
    return String(template)
      .replace(/\{\{\s*amount\s*\}\}/g, formatted)
      .replace(/\{amount\}/g, formatted)
  },

  leftSuffix: function(amount) {
    var i18n = this.i18n()
    var left = this.tpl(i18n.left || '({amount} left)', amount)
    return left ? ' <span class="gift-left">' + left + '</span>' : ''
  },

  stepMsgKeys: function(step) {
    if (step.key === 'shipping') {
      return { next: 'shipping_next', earned: 'shipping_earned' }
    }
    if (step.key === 'flask') {
      return { next: 'flask_next', earned: 'flask_earned' }
    }
    if (step.type === 'frother') {
      return { next: 'frother_next', earned: 'frother_earned' }
    }
    return { next: 'immunity_next', earned: 'immunity_earned' }
  },

  stepReached: function(cart, cartTotal, step) {
    if (cartTotal >= step.threshold) return true
    if (step.kind === 'gift') return FreeGifts.hasFreeGift(cart, step.type)
    return false
  },

  updateCampaign: function($root, cart, cartTotal, steps) {
    var i18n = this.i18n()
    var check = String.fromCharCode(0x2713) + ' '
    var euro = String.fromCharCode(0x20AC)
    var max = steps.length ? steps[steps.length - 1].threshold : 1
    var percent = Math.min((cartTotal / max) * 100, 100)
    var msKeys = ['gift1', 'shipping', 'flask']

    $root.addClass('is-gift-campaign')
    $root.find('.gift-msg').removeClass('is-visible')

    msKeys.forEach(function (key) {
      $root.find('.js-ms-' + key).hide()
    })

    var reachedFlags = steps.map(function (step) {
      return FreeShipping.stepReached(cart, cartTotal, step)
    })

    var nextIndex = -1
    for (var i = 0; i < reachedFlags.length; i++) {
      if (!reachedFlags[i]) {
        nextIndex = i
        break
      }
    }

    steps.forEach(function (step, index) {
      var reached = reachedFlags[index]
      var keys = FreeShipping.stepMsgKeys(step)
      var $ms = $root.find('.js-ms-' + step.key)

      if ($ms.length) {
        $ms.show().css('left', ((step.threshold / max) * 100) + '%')
        FreeShipping.setMilestone($ms, reached, index === nextIndex, step.threshold + euro)
      }

      if (reached) {
        FreeShipping.setMsg(
          $root.find('.js-msg-' + step.key + '-earned'),
          true,
          check + (i18n[keys.earned] || '')
        )
      }
    })

    if (nextIndex >= 0) {
      var next = steps[nextIndex]
      var nextKeys = this.stepMsgKeys(next)
      var left = Math.max(next.threshold - cartTotal, 0)
      this.setMsg(
        $root.find('.js-msg-' + next.key + '-next'),
        true,
        this.tpl(i18n[nextKeys.next] || '', next.threshold) + this.leftSuffix(left)
      )
    }

    $root.find('.gauge-fill').css('width', percent + '%')
  },

  update: function(cart) {
    var $root = $('.to-free-shipping')
    if (!$root.length) return

    if (!window.FreeGifts || !FreeGifts.isEnabled()) {
      $root.css('visibility', 'hidden')
      return
    }

    var cartTotal = FreeGifts.eligibleTotal(cart) / 100
    var lang = FreeGifts.getCampaignLang(cart)
    var steps = FreeGifts.getSteps(lang)

    if (cartTotal > 0 && steps.length) {
      $root.css('visibility', 'unset')
      this.updateCampaign($root, cart, cartTotal, steps)
    } else {
      $root.css('visibility', 'hidden')
    }
  }
}

window.FreeGifts = (function () {
  // false = hide gauge + stop auto-gifts entirely
  const ENABLED = true

  const PROP_KEY = '_added-free'
  const PROP_LANG = '_added-free-lang'

  const TYPE_FROTHER = 'frother'
  const TYPE_IMMUNITY = 'immunity'
  // const TYPE_IMMUNITY = 'frother'
  const TYPE_FLASK = 'flask'

  // Gifts in cart - sem se skopira variant ID od GIFT izdelka (bundle)
  // V orders-with-gifts se skopira product ID od pravega izdelka (ne gift)

  const VARIANT_FROTHER = 62583987208579 // <- mali kozarec, kozarec: 62394479968643 // frother: 62301880025475
  const VARIANT_FLASK = 62689502495107 //  <-   bpa sand: 62422558278019,  tangerine: 62301796368771
  const VARIANT_IMMUNITY = 62583987208579 // <- mali kozarec. kozarec: 62394479968643 // immunity: 62306802631043

  const state = {
    config: null,
    syncing: false
  }

  function loadConfig() {
    if (state.config) return state.config
    const el = document.getElementById('free-gifts-config')
    if (!el) return null
    try {
      state.config = JSON.parse(el.textContent)
    } catch (e) {
      console.error('FreeGifts: invalid config JSON', e)
      state.config = null
    }
    return state.config
  }

  function isEnabled() {
    return ENABLED && !!loadConfig()
  }

  function currentLocale() {
    return typeof g_locale !== 'undefined' && g_locale ? g_locale : 'en'
  }

  function getCampaignLang(cart) {
    if (cart && cart.items) {
      for (var i = 0; i < cart.items.length; i++) {
        var item = cart.items[i]
        if (item.properties && item.properties[PROP_KEY] && item.properties[PROP_LANG]) {
          return item.properties[PROP_LANG]
        }
      }
    }
    return currentLocale()
  }

  /*
    Gauge / auto-gift steps (ordered by threshold).
    Comment out any steps.push(...) block to remove that milestone.
  */
  function getSteps(lang) {
    var steps = []

    // Gift 1 @ 45 (frother on SL, Immunity Hero elsewhere)
    // if (lang === 'sl') {
    //   steps.push({
    //     key: 'gift1',
    //     kind: 'gift',
    //     type: TYPE_FROTHER,
    //     threshold: 45,
    //     variantId: VARIANT_FROTHER
    //   })
    // } else {
    //   steps.push({
    //     key: 'gift1',
    //     kind: 'gift',
    //     type: TYPE_IMMUNITY,
    //     threshold: 45,
    //     variantId: VARIANT_IMMUNITY
    //   })
    // }

    // Free shipping @ 50 (SL / HR / SK only) — comment out to remove
    if (lang === 'sl' || lang === 'hr' || lang === 'sk') {
      steps.push({
        key: 'shipping',
        kind: 'shipping',
        threshold: 50
      })
    }

    // Free flask — comment out to remove
    steps.push({
      key: 'flask',
      kind: 'gift',
      type: TYPE_FLASK,
      threshold: (lang === 'sl' || lang === 'hr' || lang === 'sk') ? 75 : 75,
      variantId: VARIANT_FLASK
    })

    return steps
  }

  function isFreeGiftItem(item) {
    return !!(item && item.properties && item.properties[PROP_KEY])
  }

  function freeGiftType(item) {
    return item && item.properties ? item.properties[PROP_KEY] : null
  }

  function hasFreeGift(cart, type) {
    if (!cart || !cart.items) return false
    return cart.items.some(function (item) {
      return freeGiftType(item) === type
    })
  }

  function eligibleTotal(cart) {
    if (!cart || !cart.items) return 0
    return cart.items.reduce(function (sum, item) {
      if (isFreeGiftItem(item)) return sum
      return sum + (item.final_line_price || item.line_price || 0)
    }, 0)
  }

  function findFreeItems(cart, type) {
    if (!cart || !cart.items) return []
    return cart.items.filter(function (item) {
      return freeGiftType(item) === type
    })
  }

  function findAllFreeItems(cart) {
    if (!cart || !cart.items) return []
    return cart.items.filter(isFreeGiftItem)
  }

  function fetchCart() {
    return Promise.resolve(
      $.ajax({
        type: 'GET',
        url: (typeof g_locale_url !== 'undefined' ? g_locale_url : '/') + 'cart.js',
        dataType: 'json'
      })
    ).then(function (cart) {
      CartManager.getCart.onLoad(cart)
      return cart
    })
  }

  function addFreeItem(variantId, type, lang) {
    var props = {}
    props[PROP_KEY] = type
    props[PROP_LANG] = lang
    return Promise.resolve(
      CartManager.v2.changeCart({
        add: [{
          id: variantId,
          quantity: 1,
          properties: props
        }]
      })
    )
  }

  function removeItems(items) {
    if (!items || !items.length) return Promise.resolve()
    return Promise.resolve(
      CartManager.v2.changeCart({
        update: items.map(function (item) {
          return { key: item.key, quantity: 0 }
        })
      })
    )
  }

  function reloadMiniCart() {
    if (window.Alpine && Alpine.store('xMiniCart')) {
      Alpine.store('xMiniCart').reLoad()
    }
  }

  function syncGiftStep(chain, cart, total, step, lang, markMutated) {
    var items = findFreeItems(cart, step.type)
    var thr = Math.round(step.threshold * 100)

    if (total < thr && items.length) {
      markMutated()
      chain = chain.then(function () {
        return removeItems(items)
      })
    } else if (total >= thr && items.length === 0) {
      markMutated()
      chain = chain.then(function () {
        return addFreeItem(step.variantId, step.type, lang)
      })
    } else if (items.length > 1) {
      markMutated()
      chain = chain.then(function () {
        return removeItems(items.slice(1))
      })
    }

    return chain
  }

  function sync() {
    if (!isEnabled()) return Promise.resolve(false)
    if (state.syncing) return Promise.resolve(false)

    state.syncing = true
    var mutated = false
    function markMutated() { mutated = true }

    return fetchCart()
      .then(function (cart) {
        var lang = getCampaignLang(cart)
        var steps = getSteps(lang)
        var total = eligibleTotal(cart)
        var giftTypesWanted = {}
        var chain = Promise.resolve()

        steps.forEach(function (step) {
          if (step.kind === 'gift') giftTypesWanted[step.type] = true
        })

        // Remove gifts that are not part of the current campaign steps
        ;[TYPE_FROTHER, TYPE_IMMUNITY, TYPE_FLASK].forEach(function (type) {
          if (giftTypesWanted[type]) return
          var extras = findFreeItems(cart, type)
          if (!extras.length) return
          markMutated()
          chain = chain.then(function () {
            return removeItems(extras)
          })
        })

        steps.forEach(function (step) {
          if (step.kind !== 'gift') return
          chain = syncGiftStep(chain, cart, total, step, lang, markMutated)
        })

        return chain.then(function () {
          if (mutated) return fetchCart()
        })
      })
      .then(function () {
        return mutated
      })
      .finally(function () {
        state.syncing = false
      })
  }

  function afterCartChange() {
    if (!isEnabled()) return Promise.resolve()
    return sync().then(function (mutated) {
      if (mutated) reloadMiniCart()
      if (typeof FreeShipping !== 'undefined' && CartManager.lastCart) {
        FreeShipping.update(CartManager.lastCart)
      }
    })
  }

  function init() {
    $(function () {
      if (!isEnabled()) return
      afterCartChange()
    })
  }

  return {
    ENABLED: ENABLED,
    PROP_KEY: PROP_KEY,
    PROP_LANG: PROP_LANG,
    init: init,
    sync: sync,
    afterCartChange: afterCartChange,
    isFreeGiftItem: isFreeGiftItem,
    isEnabled: isEnabled,
    loadConfig: loadConfig,
    getCampaignLang: getCampaignLang,
    getSteps: getSteps,
    hasFreeGift: hasFreeGift,
    eligibleTotal: eligibleTotal,
    findAllFreeItems: findAllFreeItems
  }
})()

FreeGifts.init()
